var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10C0 4.48 4.48 0 10 0C15.52 0 20 4.48 20 10C20 15.52 15.52 20 10 20C4.48 20 0 15.52 0 10ZM13.1832 9.94265L12.2315 10.9155C11.6181 11.5395 11.1845 12.0788 11.0471 13.094C10.9836 13.5487 10.4015 13.9082 9.93619 13.9082C9.38629 13.9082 8.84748 13.4112 8.92151 12.8613C9.03783 11.899 9.48198 11.0424 10.127 10.3868L11.4383 9.05436C11.819 8.67366 12.0517 8.14492 12.0517 7.5633C12.0517 6.40006 11.0999 5.44832 9.9367 5.44832C9.01668 5.44832 8.22357 6.05109 7.93804 6.87593C7.76166 7.37794 7.29409 7.5633 6.76534 7.54677C6.2366 7.53025 5.67229 7.08108 5.87593 6.36833C6.3941 4.6129 8.01207 3.33333 9.9367 3.33333C12.2738 3.33333 14.1667 5.22624 14.1667 7.5633C14.1667 8.49389 13.786 9.33988 13.1832 9.94265ZM11.1829 15.8157C11.1829 16.4723 10.6507 17.0045 9.99414 17.0045C9.33758 17.0045 8.80534 16.4723 8.80534 15.8157C8.80534 15.1592 9.33758 14.6269 9.99414 14.6269C10.6507 14.6269 11.1829 15.1592 11.1829 15.8157Z",
    fill: "#292E52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.0f273c7c.svg";
export { ForwardRef as ReactComponent };